import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import clsx from "../lib/clsx";
import { Wordmark } from "./Logo";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/70 backdrop-blur-xl border-b border-px-line">
      <div className="mk-container flex items-center justify-between h-16">
        <Link to="/" onClick={() => setOpen(false)}>
          <Wordmark />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          <NavItem to="/science">Science</NavItem>
          <NavItem to="/method">Method</NavItem>
          <NavItem to="/articles">Articles</NavItem>
          <NavItem to="/pricing">Pricing</NavItem>
          <NavItem to="/about">About</NavItem>
          <Link to="/#newsletter" className="mk-button-accent text-sm ml-3">Newsletter →</Link>
        </nav>

        <button
          className="lg:hidden size-10 grid place-items-center rounded-lg border border-px-line bg-white"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen((o) => !o)}
        >
          <span className="text-lg leading-none">{open ? "✕" : "☰"}</span>
        </button>
      </div>

      {open ? (
        <div id="mobile-navigation" className="lg:hidden border-t border-px-line bg-white">
          <div className="mk-container py-4 flex flex-col gap-2">
            <MobileItem to="/science" onClick={() => setOpen(false)}>Science</MobileItem>
            <MobileItem to="/method" onClick={() => setOpen(false)}>Method</MobileItem>
            <MobileItem to="/articles" onClick={() => setOpen(false)}>Articles</MobileItem>
            <MobileItem to="/pricing" onClick={() => setOpen(false)}>Pricing</MobileItem>
            <MobileItem to="/about" onClick={() => setOpen(false)}>About</MobileItem>
            <Link to="/#newsletter" onClick={() => setOpen(false)} className="mk-button-accent w-full text-center">Newsletter →</Link>
          </div>
        </div>
      ) : null}
    </header>
  );
}

function NavItem({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(
          "text-sm font-medium px-3 py-2 rounded-lg",
          isActive ? "text-px-text bg-px-line/60" : "text-px-text-soft hover:text-px-text",
        )
      }
    >
      {children}
    </NavLink>
  );
}

function MobileItem({ to, children, onClick }: { to: string; children: React.ReactNode; onClick: () => void }) {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        clsx(
          "py-3 px-4 rounded-xl font-medium",
          isActive ? "bg-px-line/60 text-px-text" : "text-px-text-soft",
        )
      }
    >
      {children}
    </NavLink>
  );
}
